export default {
      id: "ic_dropdown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#ic_dropdown",
      toString: function () {
        return this.url;
      }
    }